import { User } from 'types/userInfo';
import L from 'leaflet';
import assetLocationIcon from '../icons/asset-location-icon.svg';
import staleIcon from '../icons/stale-asset.svg';
import { differenceInSeconds } from 'date-fns';
import { Asset } from 'types/asset';
import { Device } from 'types/device';

export function getIconFromEstimateFreshness(
  estimate: Asset,
  freshPeriodThresholdSeconds: number,
) {
  // function to return correct icon based on estimate age, from config defined values.
  const timeNow = new Date();
  const timeDifferenceInSeconds = differenceInSeconds(
    timeNow,
    new Date(estimate.last_location_update_timestamp),
  );
  const estimateIsFresh = timeDifferenceInSeconds <= freshPeriodThresholdSeconds;
  return estimateIsFresh ? assetLocationIcon : staleIcon;
}


export function getCoordsFromItems(items: Asset[] | User[] | Device[]) {
  return items.map((item) => ([
    item.location.coordinates.latitude,
    item.location.coordinates.longitude,
  ]))
}


export function getCombinedLevelItemBounds(
  assets: Asset[],
  users: User[],
  devices: Device[],
  levels: any,
) {
  // function to return bounds for map that includes all levels and markers.
  // To account for outside marked building assets too
  const bounds = L.geoJSON(levels).getBounds();
  const assetCoords: any = getCoordsFromItems(assets);
  const userCoords: any = getCoordsFromItems(users);
  const deviceCoords: any = getCoordsFromItems(devices);

  bounds.extend(assetCoords);
  bounds.extend(userCoords);
  bounds.extend(deviceCoords);

  return bounds;
}
